import { MenuItem, MenuItemDefinition, NavigationOptions } from '@neos/core'
import { getViewport } from '@neos/shared'

export const menuItems: Record<string, MenuItemDefinition> = {
  ActionPanel: {
    to: 'ActionPanelUI',
  },
  Actions: {
  },
  ApplicationContext: {
    to: 'ApplicationContextUI',
  },
  Avatar: {
    to: 'AvatarUI',
  },
  BooleanFormField: {
    to: 'BooleanFormFieldUI',
  },
  Bug28166: {
    to: 'Bug28166UI',
  },
  Button: {
  },
  ButtonCustomTemplateUI: {
    to: 'ButtonCustomTemplateUI',
  },
  ButtonUI: {
    to: 'ButtonUI',
  },
  ButtonWithContentAlignMenuEntry: {
    to: 'ButtonWithContentAlignUI',
  },
  CancelPositionChangingDatagridUI: {
    to: 'CancelPositionChangingDatagridUI',
  },
  CanvasLayout: {
    to: 'CanvasLayoutComponentUI',
  },
  Card: {
    to: 'CardComponentUI',
  },
  Carousel: {
    to: 'CarouselUI',
  },
  CharacterCasingStringFormField: {
    to: 'CharacterCasingStringFormFieldUI',
  },
  CharacterCasingStringTextbox: {
    to: 'CharacterCasingStringTextboxUI',
  },
  Chart: {
    to: 'ChartUI',
  },
  Code: {
  },
  CodeEditor: {
  },
  CodeEditorDefaultTemplate: {
    to: 'TemplateCodeEditorUI',
  },
  CodeEditorReadOnlyTemplate: {
    to: 'ReadOnlyTemplateCodeEditorUI',
  },
  Combobox: {
  },
  ComboboxDefault: {
    to: 'ComboboxDefaultUI',
  },
  ComboboxDefaultEx: {
    to: 'ComboboxDefaultUIEx',
  },
  ComboboxDefaultStates: {
    to: 'ComboboxDefaultUIStates',
  },
  ComboboxEditableDefaultUI: {
    to: 'ComboboxEditableDefaultUI',
  },
  ComboboxHorizontalRadio: {
    to: 'ComboboxHorizontalRadioUI',
  },
  ComboboxSelectButton: {
    to: 'ComboboxSelectButtonUI',
  },
  ComboboxVerticalRadio: {
    to: 'ComboboxVerticalRadioUI',
  },
  Containers: {
  },
  Content: {
  },
  ContextWithSource: {
    to: 'ContextWithSourceUI',
  },
  Data: {
  },
  Datagrid: {
  },
  DatagridCustomColumnButton: {
    to: 'DatagridCustomColumnButton',
  },
  DatagridCustomColumnEditButton: {
    to: 'DatagridCustomColumnEditButton',
  },
  DatagridInTabs: {
    to: 'DatagridInTabsUI',
  },
  DatagridPagination: {
    to: 'DatagridPagination',
  },
  DatagridPartiallyLoadedServerGroup: {
    to: 'DatagridPartiallyLoadedServerGroupUI',
  },
  DatagridRowActions: {
    to: 'DatagridRowActionsUI',
  },
  DatagridWithButtonsPreviousNext: {
    to: 'DatagridButtonsNextPrevious',
  },
  DatagridWithButtonsPreviousNextServer: {
    to: 'DatagridButtonsNextPreviousServer',
  },
  DatagridWithInfiniteScrolling: {
    to: 'DatagridWithInfiniteScrolling',
  },
  DatagridWithoutSelectionColumn: {
    to: 'DatagridWithoutSelectionColumnUI',
  },
  DatagridWithSwitch: {
    to: 'DatagridWithSwitchUI',
  },
  DateFormField: {
    to: 'DateFormFieldUI',
  },
  DecimalFormField: {
    to: 'DecimalFormFieldUI',
  },
  DefaultDatagrid: {
    to: 'DefaultDatagridUI',
  },
  DefaultLocalizableStringFormField: {
    to: 'LocalizableStringFormFieldUI',
  },
  DefaultStringFormField: {
    to: 'DefaultStringFormFieldUI',
  },
  Detail: {
    to: 'DetailEntityUI',
  },
  DetailWithReference: {
    to: 'DetailEntityWithReferenceUI',
  },
  DGDragDrop: {
    to: 'DGDragDropUI',
  },
  DGRowDetailMaster: {
    to: 'DGRowDetailMasterUI',
  },
  DGRowDetailMasterExpandedByDefault: {
    to: 'DGRowDetailMasterExpandedByDefaultUI',
  },
  DirectiveLayoutAlignSelf: {
    to: 'DirectiveLayoutAlignSelfUI',
  },
  DirectiveLayoutHeightAndWidthMenuEntry: {
    to: 'DirectiveLayoutHeightAndWidthUI',
  },
  DirectiveLayoutRenderedSize: {
    to: 'DirectiveLayoutRenderedSizeUI',
  },
  DirectivePlaygroundMenuEntry: {
    to: 'DirectivePlaygroundUI',
  },
  Directives: {
  },
  DirectiveStyleClassesMenuEntry: {
    to: 'DirectiveStyleClassesUI',
  },
  DirectiveStyleCornerRadiusMenuEntry: {
    to: 'DirectiveStyleCornerRadiusUI',
  },
  Divider: {
  },
  DividerMenuEntry: {
    to: 'DividerComponentUI',
  },
  DividerWithConentAlignMenuItem: {
    to: 'DividerWithContentAlignUI',
  },
  DocumentationButton: {
    to: 'DocumentationButtonUI',
  },
  Enumeration: {
  },
  ExhaustiveLookupFormFieldMenuGroup: {
  },
  ExhaustiveLookupFormFieldReferenceMI: {
    to: 'ExhaustiveLookupFormFieldReferenceUI',
  },
  ExhaustiveLookupFormFieldScalarPropertyChooseOnlyMI: {
    to: 'ExhaustiveLookupFormFieldScalarPropertyChooseOnlyUI',
  },
  ExhaustiveLookupFormFieldScalarPropertyWithAllowFreeValueMI: {
    to: 'ExhaustiveLookupFormFieldScalarPropertyWithAllowFreeValueUI',
  },
  ExhaustiveLookupFormFieldScalarPropertyWithAllowFreeValueProperty: {
    to: 'LookupScalarPropertyWithUIViewLookupFreeValuePropertyUI',
  },
  ExhaustiveLookupUnboundMI: {
    to: 'ExhaustiveLookupUnboundUI',
  },
  ExpressionEditor: {
    to: 'ExpressionEditorUI',
  },
  File: {
  },
  FileFormField: {
    to: 'FileFormFieldUI',
  },
  FileUpload: {
    to: 'FileUploadUI',
  },
  FilterBarChip: {
    to: 'FilterBarChipUI',
  },
  FilterBarUI: {
    to: 'FilterBarUI',
  },
  FilterBarWithRequiredFilterUI: {
    to: 'FilterBarWithRequiredFilterUI',
  },
  Filtering: {
  },
  FormFieldFocus: {
    to: 'FormFieldFocusUI',
  },
  FormFieldInRepeat: {
    to: 'FormFieldInRepeatUI',
  },
  FormFieldValidationMessage: {
    to: 'FormFieldValidationMessageUI',
  },
  GlobalSearchButton: {
    to: 'GlobalSearchButtonUI',
  },
  GlobalSearchInput: {
    to: 'GlobalSearchInputUI',
  },
  GridLayout: {
    to: 'GridLayoutComponentUI',
  },
  GridLayoutResponsive: {
    to: 'GridLayoutResponsiveUI',
  },
  GroupBox: {
    to: 'GroupBoxComponentUI',
  },
  GuidKeyEntity: {
    to: 'GuidKeyEntityUI',
  },
  Heading: {
    to: 'HeadingComponentUI',
  },
  HorizontalLayout: {
    to: 'HorizontalLayoutComponentUI',
  },
  HorizontalScroll: {
    to: 'HorizontalScroll',
  },
  HtmlViewer: {
    to: 'HtmlViewerExampleUI',
  },
  Image: {
  },
  ImageFormFieldUI: {
    to: 'ImageFormFieldUI',
  },
  ImageUI: {
    to: 'ImageUI',
  },
  ImageUploadUI: {
    code: async function(this: MenuItem) {
      let options = new NavigationOptions('FileUploadUI').withParameter('MimeType', 'image/jpeg').withFrameId('ImageUploadUI').withTitle(this.caption);
      this.navigateAsync(options);
    },
  },
  InputFile: {
    to: 'InputFileUI',
  },
  InputImageUI: {
    to: 'InputImageUI',
  },
  Inputs: {
  },
  InputStylesDirectives: {
    to: 'InputDirectiveStyleUI',
  },
  IntegerKeyEntity: {
    to: 'IntegerKeyEntityUI',
  },
  IsSettableUI: {
    to: 'IsSettableUI',
  },
  LabelPositionFormFields: {
    to: 'LabelPositionFormFieldUI',
  },
  Layout: {
  },
  LoadDataOnScroll: {
    to: 'LoadDataOnScrollUI',
  },
  LocalizableString: {
    to: 'LocalizableStringFormFieldUI',
  },
  LocalizableStringGroup: {
  },
  Lookup: {
  },
  LookupCreationUI: {
    to: 'LookupCreationUI',
  },
  LookupDifferentEntityViews: {
    to: 'LookupFormFieldReferenceDifferentEntityViewsUI',
  },
  LookupEditingUI: {
    to: 'LookupEditingUI',
  },
  LookupFormFieldQuickSearch: {
    to: 'LookupQuickSearchUI',
  },
  LookupFormFieldReference: {
    to: 'LookupFormFieldReferenceUI',
  },
  LookupFormFieldReferenceCustomModal: {
    to: 'LookupFormFieldReferenceCustomModalUI',
  },
  LookupFormFieldScalarProperty: {
    to: 'LookupFormFieldScalarPropertyUI',
  },
  LookupFormFieldScalarPropertyFreeValue: {
    to: 'LookupFormFieldScalarPropertyFreeValueUI',
  },
  LookupLocalizableDisplay: {
    to: 'LookupLocalizableDisplayUI',
  },
  LookupScalarPropertyMainEntity: {
    to: 'LookupScalarPropertyMainEntityUI',
  },
  LookupSuggestionProperties: {
    to: 'UnboundLookupSuggestionPropertiesUI',
  },
  MarkdownViewer: {
    to: 'MarkdownViewerUI',
  },
  MaskFormField: {
    to: 'MaskFormFieldUI',
  },
  Master: {
    to: 'MasterEntityUI',
  },
  MasterEntityUIWithEditableDatagrid: {
    to: 'MasterEntityUIWithEditableDatagridUI',
  },
  MasterEntityWithDetail: {
    to: 'MasterEntityWithDetailUI',
  },
  MasterEntityWithItemCloningEvent: {
    to: 'MasterEntityWithItemCloningEventUI',
  },
  MaxLengthStringFormField: {
    to: 'MaxLengthStringFormFieldUI',
  },
  Menu: {
  },
  MenuItemsBinding: {
    to: 'MenuItemsBindingUI',
  },
  MenuItemWithCode: {
    code: async function(this: MenuItem) {
      await this.navigateAsync(new NavigationOptions('DefaultBooleanFormFieldUI').withTitle('UI view opened by the code of a menu item'));
    },
  },
  Message: {
    to: 'MessageUI',
  },
  MultilineStringFormField: {
    to: 'MultilineStringFormFieldUI',
  },
  MultilineTextboxesLayout: {
    to: 'LayoutWithMultilineTextboxes',
  },
  MultiSelect: {
    to: 'MultiSelectUI',
  },
  NavigateToDetailDatagrid: {
    to: 'NavigateToDetailDatagridUI',
  },
  Navigation: {
  },
  NestedTabs: {
    to: 'NestedTabsUI',
  },
  NullableEnumFormField: {
    to: 'NullableEnumFormFieldUI',
  },
  Overlay: {
    to: 'OverlayComponentsUI',
  },
  PartialTemplateSlotsMenuEntry: {
    to: 'PartialTemplateSlotsUI',
  },
  PasswordFormField: {
    to: 'PasswordFormFieldUI',
  },
  Placeholder: {
    to: 'PlaceholderInputFormFieldUI',
  },
  PlaceholderInputFormField: {
    to: 'PlaceholderInputFormFieldUI',
  },
  PlaceholderTextbox: {
    to: 'PlaceholderTextboxUI',
  },
  ProgressBar: {
    to: 'ProgressBarUI',
  },
  ReadOnlyDatagrid: {
    to: 'ReadOnlyDatagridUI',
  },
  ReadOnlyDatagridWithoutLoadOnStart: {
    to: 'ReadOnlyDatagridWithoutLoadOnStartUI',
  },
  ReadOnlyEnumFormField: {
    to: 'ReadOnlyEnumFormFieldUI',
  },
  RenderedSizeWorkspace: {
    visible: function(this: MenuItem) {
      return getViewport().isWidthAtLeastLarge;
    },
    to: 'RenderedSizeWorkspaceUI',
  },
  Repeat: {
  },
  RepeatDatasource: {
    to: 'RepeatDatasourceUI',
  },
  RepeatWithHorizontalScroll: {
    to: 'RepeatWithHorizontalScrollUI',
  },
  RepeatWithVerticalScroll: {
    to: 'RepeatWithVerticalScrollUI',
  },
  Responsive: {
  },
  RichTextFormField: {
    to: 'RichTextFormFieldUI',
  },
  Scroll: {
  },
  ShortcutLocalizableString: {
    to: 'ShortcutLocalizableStringUI',
  },
  ShowMessageUI: {
    to: 'ShowMessageUI',
  },
  ShowToastUI: {
    to: 'ShowToastUI',
  },
  SliderDiscrete: {
    to: 'SliderDiscreteUI',
  },
  Spinner: {
    to: 'SpinnerUI',
  },
  Splitter: {
  },
  SplitterWithMainAndDetailPanels: {
    to: 'SplitterWithMainAndDetailPanelsUI',
  },
  String: {
  },
  StyleClassNeosTargetMenuEntry: {
    to: 'StyleClassNeosTargetUI',
  },
  Tabs: {
    to: 'TabsUI',
  },
  TestCases: {
  },
  Text: {
    to: 'TextComponentUI',
  },
  Textbox: {
  },
  Timeline: {
    to: 'TimelineUI',
  },
  Toolbar: {
  },
  ToolbarButtonAccessors: {
    to: 'ToolbarsUI',
  },
  UIComponentInColumnTemplate: {
    to: 'UIComponentInColumnTemplate',
  },
  UIComponents: {
  },
  UIComponentWithComputed: {
    to: 'UIComponentWithComputedUI',
  },
  UIComponentWithContent: {
    to: 'UIComponentWithContentUI',
  },
  UIComponentWithEventRules: {
    to: 'UIComponentWithEventRulesUI',
  },
  UIComponentWithFallbackContent: {
    to: 'UIComponentWithFallbackContentUI',
  },
  UIComponentWithParameters: {
    to: 'UIComponentWithParametersUI',
  },
  UnboundLookup: {
    to: 'UnboundLookupUI',
  },
  UserButton: {
    to: 'UserButtonUI',
  },
  VerticalLayout: {
    to: 'VerticalLayoutComponentUI',
  },
  ViewportBreakpoints: {
    to: 'ViewportBreakpointsUI',
  },
  WebView: {
    to: 'WebViewExternal',
  }
}